import React, { useEffect } from 'react';
var moduleId = Symbol('procedureLinksModule');
export function procedureLinksModule() {
    return {
        id: moduleId,
        layouts: {
            portal: function () {
                return React.createElement(ActivateNodeLinkHandler, null);
            }
        },
        hooks: function (_a) {
            var navigate = _a.navigate, navigation = _a.navigation;
            return ({
                documentMessage: function (document, message) {
                    if (isOpenDocumentFragmentMessage(message)) {
                        navigate(navigation.document(document, {
                            fragment: message.fragment
                        }));
                        return true;
                    }
                    return false;
                }
            });
        }
    };
}
function isOpenDocumentFragmentMessage(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value) &&
        'type' in value && value.type === 'open-document-fragment' &&
        'fragment' in value && typeof value.fragment === 'string';
}
var ActivateNodeLinkHandler = function () {
    useEffect(function () {
        function activateNodeLink(targetId) {
            var message = {
                type: 'open-document-fragment',
                fragment: targetId
            };
            postMessage(message, '*');
        }
        Object.defineProperty(window, 'activateNodeLink', {
            value: activateNodeLink,
            configurable: true
        });
        return function () {
            delete window.activateNodeLink;
        };
    });
    return null;
};
